// mimeType or wildcard (e.g. application/*) and error message if matched
export const mimeBlacklist = {
  'video/*': 'Video files are not allowed',
  'audio/*': 'Audio files are not allowed'
};
